import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TodaySection from "./components/TodaySection";
import CalendarPreview from "./components/CalendarPreview";
import PopularSection from "./components/PopularSection";
import CategorySection from "./components/CategorySection";
import NewsSection from "./components/NewsSection";
import FaqSection from "./components/FaqSection";
import CtaSection from "./components/CtaSection";
import { faqList } from "@/mocks/anime";

const jsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "妖精动漫网",
      url: "https://comicnot.github.io/",
      inLanguage: "zh-CN",
      description: "妖精动漫网专注新番更新追踪与追番日历，汇总本周新番、连载动漫与完结动漫动态。",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: "https://comicnot.github.io/series?q={search_term_string}",
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "妖精动漫网",
      url: "https://comicnot.github.io/",
      logo: "https://comicnot.github.io/logo.png",
    },
    {
      "@type": "FAQPage",
      mainEntity: faqList.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <TodaySection />
        <CalendarPreview />
        <PopularSection />
        <CategorySection />
        <NewsSection />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}